import Navbar from "./components/navbar/Navbar"

import Drive from "./pages/Drive"
import Rotor from "./pages/Rotor"
import Home from "./pages/Home"
import About from "./pages/About"
import Contact from "./pages/Contact"
import { Route, Routes } from "react-router-dom"


function App() {
  return (
  <>

    <Navbar/>
    <div> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/drive" element={<Drive />} />
        <Route path="/rotor" element={<Rotor />} />                        
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />            
      </Routes>   
    </div>   

  </>
  )
}

export default App
